export async function fetchPublicRollout() {
  const res = await fetch('/api/rollout/public', { credentials: 'include' })
  const body = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(body.detail || '加载功能开放配置失败')
  }
  return body
}

export function capabilityEnabled(capabilities, code, fallback = false) {
  if (!capabilities || typeof capabilities !== 'object') return fallback
  const value = capabilities[code]
  if (typeof value === 'boolean') return value
  if (typeof value === 'number') return value > 0
  return fallback
}
